<agr-dialog id="offer-overview-dialog" [data]="data" (cancel)="cancel()">
  <div
    class="flex--row flex--justify-space-between border-bottom--gray4 header-container spacing--margin-bottom spacing--margin-top"
  >
    <div
      class="text--bold dialog-title-container spacing--margin-top spacing--margin-bottom spacing--margin-left"
    >
      {{ 'slideInDialog.title' | translate }}
    </div>
    <div
      (click)="cancel()"
      class="close-button-container spacing--margin-top spacing--margin-bottom spacing--margin-right"
    >
      {{ 'slideInDialog.close-button' | translate }}
    </div>
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom text--h3 title-container spacing--margin-left text--bold text--h3"
  >
    {{ 'slideInDialog.offer.header-text' | translate }}
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom table-container spacing--margin-left spacing--margin-right"
  >
    <table class="table-no-borders flex--column">
      <tr class="flex--row flex--justify-space-between spacing--margin-bottom border-bottom-gray4">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureCategories.' + data.selectedOffer?.manureCategory | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureTypes.' + data.selectedOffer?.manureType | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedOffer?.amountInTons }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedOffer?.nKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
        </td>
        <td class="max-nitrogen-field spacing--margin-left spacing--margin-bottom">
          @if (data.selectedOffer?.nKgPerTon) {
            {{ data.selectedOffer?.nKgPerTon * data.selectedOffer?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedOffer?.pKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom max-phosphate-field">
          @if (data.selectedOffer?.pKgPerTon) {
            {{ data.selectedOffer?.pKgPerTon * data.selectedOffer?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedOffer?.kKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right spacing--margin-bottom">{{
            'dashboard.overview-table.table-headers.homogeneous' | translate
          }}</span>
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          <div>
            @switch (data.selectedOffer?.isHomogeneous) {
              @case (true) {
                <p>{{ 'homogeneity.homogeneous' | translate }}</p>
              }
              @case (false) {
                <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
              }
              @case (null) {
                <p>{{ 'homogeneity.empty' | translate }}</p>
              }
            }
          </div>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.distance' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left">{{
            'distance.' + data.selectedOffer?.distance | translate
          }}</span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left"
            >{{
              data.selectedOffer?.desiredDeliveryPeriodFrom
                ? ('shorthand-months.' + data.selectedOffer?.desiredDeliveryPeriodFrom | translate)
                : ('' | translate)
            }}
            {{
              data.selectedOffer?.desiredDeliveryPeriodFrom &&
              data.selectedOffer?.desiredDeliveryPeriodTo
                ? '-'
                : ''
            }}
            {{
              data.selectedOffer?.desiredDeliveryPeriodTo
                ? ('shorthand-months.' + data.selectedOffer?.desiredDeliveryPeriodTo | translate)
                : ('' | translate)
            }}
          </span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.paymentType' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          @if (data.selectedOffer?.paymentType === 'Pay') {
            <span class="you-receive-container text--center">
              {{ 'dashboard.overview-table.paymentType.Receive' | translate }}
            </span>
          } @else {
            <span class="you-pay-container text--center">
              {{ 'dashboard.overview-table.paymentType.Pay' | translate }}
            </span>
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.pricePerTon' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left">{{
            data.selectedOffer?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right test">{{
            'dashboard.overview-table.table-headers.price' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left total-price-field">{{
            data.selectedOffer?.amountInTons * data.selectedOffer?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>
    </table>

    <div
      class="spacing--margin-top spacing--margin-bottom text--label information-container border-bottom--gray4"
    >
      *{{ 'resume-page.offer.transport-info' | translate }}
    </div>
  </div>

  <div class="spacing--margin-left spacing--margin-top border-bottom--gray4">
    <agr-form [formGroup]="formGroup">
      @if (intermediaries().length) {
        <div class="spacing--margin-top">
          <mat-label class="text--bold" style="display: block">{{
            'slideInDialog.offer.intermediary-form' | translate
          }}</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="preferredIntermediary"
              placeholder="{{ 'form.select.placeholder' | translate }}"
              data-test="select-intermediary"
            >
              @for (intermediary of intermediaries(); track intermediary) {
                <mat-option [value]="intermediary" data-test="intermediary-item">
                  {{ intermediary }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </agr-form>
  </div>

  @if (selectedLocation$ | async; as selectedLocation) {
    <div
      class="spacing--margin-top spacing--margin-bottom spacing--margin-left spacing--margin-right border-bottom--gray4"
    >
      <mat-label class="text--bold">{{
        'slideInDialog.offer.delivery-address-title' | translate
      }}</mat-label>
      <div>{{ 'slideInDialog.offer.delivery-address-text' | translate }}</div>
      <div class="location-info spacing--margin-top">
        <strong>{{ selectedLocation.name }}</strong
        ><br />
        {{ selectedLocation.street }} {{ selectedLocation.houseNumber }}<br />
        {{ selectedLocation.postalCode }} {{ selectedLocation.city }}<br />
        <span class="edit-location-link" (click)="openLocationsDialog()">Wijzig</span>
      </div>
      <div class="spacing--margin-top spacing--margin-bottom">
        {{ 'slideInDialog.offer.delivery-address-footer' | translate }}
      </div>
    </div>
  }

  <div
    class="action-buttons-container spacing--margin-left spacing--margin-right spacing--margin-bottom flex--row flex--justify-space-between"
  >
    <div class="match-button-container spacing--margin-right">
      <button
        [disabled]="formGroup.invalid"
        class="spacing--margin-right place-offer-button-container"
        mat-flat-button
        color="accent"
        (click)="makeMatch()"
        data-test="primary-action-button"
      >
        <mat-icon>add</mat-icon> {{ 'slideInDialog.match-button' | translate }}
      </button>
    </div>

    <div
      class="flex--nowrap flex--row flex--align-center flex--justify-center footer-close-button-container"
    >
      <button
        (click)="cancel()"
        class="mat-flat-button mat-focus-indicator mat-button-base footer-close-button"
      >
        <div class="footer-button-text-container">
          {{ 'slideInDialog.close-button' | translate }}
        </div>
      </button>
    </div>
  </div>
</agr-dialog>
